var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 5.60218 2.15804 5.22064 2.43934 4.93934C2.72064 4.65804 3.10218 4.5 3.5 4.5H20.5C20.8978 4.5 21.2794 4.65804 21.5607 4.93934C21.842 5.22064 22 5.60218 22 6C22 6.39782 21.842 6.77936 21.5607 7.06066C21.2794 7.34196 20.8978 7.5 20.5 7.5H3.5C3.10218 7.5 2.72064 7.34196 2.43934 7.06066C2.15804 6.77936 2 6.39782 2 6ZM6 12C6 11.6022 6.15804 11.2206 6.43934 10.9393C6.72064 10.658 7.10218 10.5 7.5 10.5H16.5C16.8978 10.5 17.2794 10.658 17.5607 10.9393C17.842 11.2206 18 11.6022 18 12C18 12.3978 17.842 12.7794 17.5607 13.0607C17.2794 13.342 16.8978 13.5 16.5 13.5H7.5C7.10218 13.5 6.72064 13.342 6.43934 13.0607C6.15804 12.7794 6 12.3978 6 12ZM10.5 16.5C10.1022 16.5 9.72064 16.658 9.43934 16.9393C9.15804 17.2206 9 17.6022 9 18C9 18.3978 9.15804 18.7794 9.43934 19.0607C9.72064 19.342 10.1022 19.5 10.5 19.5H13.5C13.8978 19.5 14.2794 19.342 14.5607 19.0607C14.842 18.7794 15 18.3978 15 18C15 17.6022 14.842 17.2206 14.5607 16.9393C14.2794 16.658 13.8978 16.5 13.5 16.5H10.5Z",
    fill: "#1C3A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGreen);
export default __webpack_public_path__ + "static/media/filter-green.9fdcc1e7b69e230d4af83cd6cd4f9fc4.svg";
export { ForwardRef as ReactComponent };